import React from 'react';
import './ProcessStep.css';

import { formatTitleWithBreak } from '../../utils';



const ProcessStep = ({step}) => {

  // Destructuring props
  const { id, icon, title, content } = step;

  return (

    <div className='process-item' key={id}>

      <div className='text'>
        <h3>{formatTitleWithBreak(title)}</h3> {/* Step Title */}
        <p>{content}</p> {/* Step Content */}
      </div>

      <div className='intro'>
        <div className='icon'>{icon}</div> {/* Step Icon */}
        <h6>0{id}</h6> {/* Step Number */}
      </div>

    </div>

  );
};

export default ProcessStep;